import React, { useCallback, useEffect, useState } from "react";
import { ModuleSection, StatusEnum } from "./type";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import CheckIcon from "@mui/icons-material/Check";
import ListItemText from "@mui/material/ListItemText";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Box from "@mui/material/Box";
import arrowRight from "../../assets/img/arrow-right.png";
import {
  completeBoxMarginStyle,
  completeBoxStyle,
  completeIconStyle,
  subheader,
  sectionItem,
  item,
} from "./style";
import { useNavigate, useNavigation } from "react-router-dom";
import { ONBOARDING_PATH, ROOT_PATH } from "../../../../routes/constants";
import style from "./style.module.css";
import { ListSubheader, Typography } from "@mui/material";
import { color } from "../../../../mui-theme/palette";
import { useQuery } from "../../../../utils/hooks/use-query";
import { getToken, parseJwt } from "../../utils";
import { OnboardingApplicationStatus, RoleEnum } from "../../types";
import { confirm } from "../../../../components/modal/comfirm";
import moment from "moment";
import { getI18n, useTranslation } from "react-i18next";
import { ExamRegistrationStatus, SignatureItem } from "../exam-menu-screen/type";
import { PruToast } from "../../../../components/pru-toast";

type MenuListProps = {
  sections?: ModuleSection[];
  npaNumber?: string;
  applicationStatus?: string;
  applicationId?: string;
  examRegistrationStatus?: ExamRegistrationStatus;
  recruiterIsAgentLeader?: boolean;
  signatureData?: SignatureItem;
  backRouteAction?: string;
  notificationActionId?: string;
};

export const MenuList = (props: MenuListProps) => {
  const {
    sections = [],
    npaNumber,
    applicationStatus,
    applicationId,
    examRegistrationStatus,
    recruiterIsAgentLeader,
    signatureData,
    backRouteAction,
    notificationActionId,
  } = props;
  const { t } = useTranslation();
  const rawToken = getToken();
  const tokenData = rawToken ? parseJwt(rawToken) : {};
  const navigate = useNavigate();
  const query = useQuery();

  const [expand, setExpand] = useState(
    new Set(sections.filter((p) => p.expanded).map((p) => p.name)),
  );
  const onClick = useCallback((name: string) => {
    setExpand((expandeds) => {
      const next = new Set(expandeds);
      next.has(name) ? next.delete(name) : next.add(name);
      return next;
    });
  }, []);

  const getRoleMessage = () => {
    const { candidateSignature, recruiterSignature, agentLeaderSignature } = signatureData || {};
    const messages = [];

    if (recruiterIsAgentLeader) {
      if (candidateSignature && !recruiterSignature) {
        messages.push(getI18n().t("onboarding.signature_pending_recruiter"));
      }
    } else {
      if (candidateSignature && !recruiterSignature) {
        messages.push(getI18n().t("onboarding.signature_pending_recruiter"));
      }
      if (candidateSignature && !agentLeaderSignature) {
        messages.push(getI18n().t("onboarding.signature_pending_manager"));
      }
    }

    return messages;
  };

  const checkStepComplete = (d: any, section: any) => {
    query.set("sectionName", d.name);
    if (
      applicationStatus == OnboardingApplicationStatus.CANCELLED ||
      applicationStatus == OnboardingApplicationStatus.REJECTED ||
      applicationStatus == OnboardingApplicationStatus.EXPIRED
    ) {
      if (tokenData.role == RoleEnum.CANDIDATE) {
        PruToast({
          message: getI18n().t(
            `onboarding.message_check_step_with_status_${applicationStatus.toLowerCase()}_candidate`,
          ),
          duration: 2000,
        });
        return false;
      } else {
        PruToast({
          message: getI18n().t(
            `onboarding.message_check_step_with_status_${applicationStatus.toLowerCase()}_recruiter`,
          ),
          duration: 2000,
        });
        return false;
      }
    }
    if (d.name == "termsNConditionsSection") {
      if (tokenData.role != RoleEnum.CANDIDATE) {
        console.log("not available");
      } else {
        window.ReactNativeWebView?.postMessage(
          '{"action": "redirectLink", "payload": "termsNConditionsSection"}',
        );
      }
    }
    if (d.name == "reinstateSection") {
      const isEligible =
        (recruiterIsAgentLeader && tokenData.role === RoleEnum.AGENT) ||
        (!recruiterIsAgentLeader && tokenData.role === RoleEnum.MANAGER);

      if (isEligible) {
        window.ReactNativeWebView?.postMessage(
          JSON.stringify({
            action: "redirectLink",
            payload: "reinstatementSection",
            npaNumber,
            backRouteAction,
          }),
        );
      }
    } else if (
      d.name == "eSignatureSection" &&
      (applicationStatus == OnboardingApplicationStatus.PENDING_SIGNATURE ||
        applicationStatus == OnboardingApplicationStatus.FOLLOW_UP_REQUIRED) &&
      tokenData.role != RoleEnum.CANDIDATE
    ) {
      const { recruiterSignature, agentLeaderSignature } = signatureData || {};
      if (applicationStatus == OnboardingApplicationStatus.PENDING_SIGNATURE) {
        window.ReactNativeWebView?.postMessage(
          `{"action": "redirectLink", "payload": "eSignatureSection", "npaNumber": "${npaNumber}", "backRouteAction": "${backRouteAction}"}`,
        );
      } else if (
        (applicationStatus == OnboardingApplicationStatus.FOLLOW_UP_REQUIRED &&
          !recruiterIsAgentLeader &&
          ((tokenData.role === RoleEnum.AGENT && recruiterSignature) ||
            (tokenData.role === RoleEnum.MANAGER && agentLeaderSignature))) ||
        (recruiterIsAgentLeader && recruiterSignature && tokenData.role === RoleEnum.MANAGER)
      ) {
        var totalSectionComplete = 0;
        var totalSectionUnComplete = 0;
        var countSection: any;
        for (var key in section) {
          totalSectionComplete += section[key].denominator;
          totalSectionUnComplete += section[key].numerator;
        }
        navigate(`${ROOT_PATH}/${ONBOARDING_PATH}/form?${query.toString()}`);
      } else {
        PruToast({
          message: "Bagian ini tidak dapat diubah. Silakan cek notifikasi",
          duration: 5000,
        });
      }
    } else if (
      d.name == "eSignatureSection" &&
      (applicationStatus == OnboardingApplicationStatus.FOLLOW_UP_REQUIRED ||
        applicationStatus == OnboardingApplicationStatus.PENDING_SIGNATURE) &&
      tokenData.role == RoleEnum.CANDIDATE &&
      (!examRegistrationStatus?.aaji || !examRegistrationStatus?.aasi)
    ) {
      confirm({
        message: t("onboarding.pending_resubmit_exam_regist"),
        confirmButtonText: "OK",
        disableCancel: true,
      });
    } else if (d.name == "examRegistrationPLAIAAJI") {
      if (
        !examRegistrationStatus?.aaji &&
        examRegistrationStatus?.step === 0 &&
        tokenData.role == RoleEnum.CANDIDATE
      ) {
        window.ReactNativeWebView?.postMessage(
          `{"action": "redirectLink", "payload": "license_exam_registration", "npaNumber": "${npaNumber}", "examType": "AAJI", "applicationId": "${applicationId}", "notificationActionId": "${notificationActionId}" }`,
        );
      } else if (
        tokenData.role == RoleEnum.CANDIDATE &&
        examRegistrationStatus?.step === 2 &&
        !examRegistrationStatus?.aaji
      ) {
        const dataAAJI = d.dataExamRegist;
        const templateScheduleAAJI = [
          `<table style='margin: auto;'>`,
          `<tr><td style='font-weight:bold'>NPA</td><td style='padding-left:20px'>:</td><td style='padding-left:20px;'>${npaNumber}</td></tr>`,
          `<tr><td style='font-weight:bold'>Tipe Ujian</td><td style='padding-left:20px'>:</td><td style='padding-left:20px;'>AAJI</td></tr>`,
          `<tr><td style='font-weight:bold'>Lokasi Ujian</td><td style='padding-left:20px'>:</td><td style='padding-left:20px;'>${dataAAJI.aajiExamLocation}</td></tr>`,
          `<tr><td style='font-weight:bold'>Tanggal Ujian</td><td style='padding-left:20px'>:</td><td style='padding-left:20px;'>${t(
            moment(dataAAJI.aajiExamDate).format("dddd"),
          )}, ${moment(dataAAJI.aajiExamDate).format("DD")} ${t(
            moment(dataAAJI.aajiExamDate).format("MMMM"),
          )} ${moment(dataAAJI.aajiExamDate).format("yyyy")}</tr>`,
          `<tr><td style='font-weight:bold;align-content:start'>Waktu Ujian</td><td style='padding-left:20px;align-content:start'>:</td><td style='padding-left:20px;'>${dataAAJI.aajiExamStartTime} - ${dataAAJI.aajiExamEndTime}<br>(Kuota Terisi: ${dataAAJI.aajiExamQuotaFilled}/${dataAAJI.aajiExamQuota})</td></tr></table>`,
        ];
        confirm({
          title: "JADWAL AAJI",
          message: templateScheduleAAJI.join(""),
          confirmButtonText: "UBAH JADWAL UJIAN",
          onConfirm: () => {
            window.ReactNativeWebView?.postMessage(
              `{"action": "redirectLink", "payload": "license_exam_registration", "npaNumber": "${npaNumber}", "examType": "AAJI", "applicationId": "${applicationId}", "notificationActionId": "${notificationActionId}" }`,
            );
          },
          cancelButtonText: "Kembali",
          disableCancel: false,
        });
      } else {
        const dataAAJI = d.dataExamRegist;
        const templateScheduleAAJI = [
          `<table style='margin: auto;'>`,
          `<tr><td style='font-weight:bold'>NPA</td><td style='padding-left:20px'>:</td><td style='padding-left:20px;'>${npaNumber}</td></tr>`,
          `<tr><td style='font-weight:bold'>Tipe Ujian</td><td style='padding-left:20px'>:</td><td style='padding-left:20px;'>AAJI</td></tr>`,
          `<tr><td style='font-weight:bold'>Lokasi Ujian</td><td style='padding-left:20px'>:</td><td style='padding-left:20px;'>${dataAAJI.aajiExamLocation}</td></tr>`,
          `<tr><td style='font-weight:bold'>Tanggal Ujian</td><td style='padding-left:20px'>:</td><td style='padding-left:20px;'>${t(
            moment(dataAAJI.aajiExamDate).format("dddd"),
          )}, ${moment(dataAAJI.aajiExamDate).format("DD")} ${t(
            moment(dataAAJI.aajiExamDate).format("MMMM"),
          )} ${moment(dataAAJI.aajiExamDate).format("yyyy")}</tr>`,
          `<tr><td style='font-weight:bold;align-content:start'>Waktu Ujian</td><td style='padding-left:20px;align-content:start'>:</td><td style='padding-left:20px;'>${dataAAJI.aajiExamStartTime} - ${dataAAJI.aajiExamEndTime}<br>(Kuota Terisi: ${dataAAJI.aajiExamQuotaFilled}/${dataAAJI.aajiExamQuota})</td></tr></table>`,
        ];
        confirm({
          title: "JADWAL AAJI",
          message: templateScheduleAAJI.join(""),
          confirmButtonText: "OK",
          disableCancel: true,
        });
      }
    } else if (d.name == "examRegistrationPLAIAASI") {
      const { examRegistrationStatus } = props;
      if (
        !examRegistrationStatus?.aasi &&
        examRegistrationStatus?.step === 0 &&
        tokenData.role == RoleEnum.CANDIDATE
      ) {
        window.ReactNativeWebView?.postMessage(
          `{"action": "redirectLink", "payload": "license_exam_registration", "npaNumber": "${npaNumber}", "examType": "AASI", "applicationId": "${applicationId}", "notificationActionId": "${notificationActionId}" }`,
        );
      } else if (
        tokenData.role == RoleEnum.CANDIDATE &&
        examRegistrationStatus?.step === 2 &&
        !examRegistrationStatus?.aasi
      ) {
        const dataAASI = d.dataExamRegist;
        const templateScheduleAASI = [
          `<table style='margin: auto;'>`,
          `<tr><td style='font-weight:bold'>NPA</td><td style='padding-left:20px'>:</td><td style='padding-left:20px;'>${npaNumber}</td></tr>`,
          `<tr><td style='font-weight:bold'>Tipe Ujian</td><td style='padding-left:20px'>:</td><td style='padding-left:20px;'>AASI</td></tr>`,
          `<tr><td style='font-weight:bold'>Lokasi Ujian</td><td style='padding-left:20px'>:</td><td style='padding-left:20px;'>${dataAASI.aajiExamLocation}</td></tr>`,
          `<tr><td style='font-weight:bold'>Tanggal Ujian</td><td style='padding-left:20px'>:</td><td style='padding-left:20px;'>${t(
            moment(dataAASI.aajiExamDate).format("dddd"),
          )}, ${moment(dataAASI.aajiExamDate).format("DD")} ${t(
            moment(dataAASI.aajiExamDate).format("MMMM"),
          )} ${moment(dataAASI.aajiExamDate).format("yyyy")}</tr>`,
          `<tr><td style='font-weight:bold;align-content:start'>Waktu Ujian</td><td style='padding-left:20px;align-content:start'>:</td><td style='padding-left:20px;'>${dataAASI.aajiExamStartTime} - ${dataAASI.aajiExamEndTime}<br>(Kuota Terisi: ${dataAASI.aajiExamQuotaFilled}/${dataAASI.aajiExamQuota})</td></tr></table>`,
        ];
        confirm({
          title: "JADWAL AASI",
          message: templateScheduleAASI.join(""),
          confirmButtonText: "UBAH JADWAL UJIAN",
          onConfirm: () => {
            window.ReactNativeWebView?.postMessage(
              `{"action": "redirectLink", "payload": "license_exam_registration", "npaNumber": "${npaNumber}", "examType": "AASI", "applicationId": "${applicationId}", "notificationActionId": "${notificationActionId}" }`,
            );
          },
          cancelButtonText: "Kembali",
          disableCancel: false,
        });
      } else {
        const dataAASI = d.dataExamRegist;
        const templateScheduleAASI = [
          `<table style='margin: auto;'>`,
          `<tr><td style='font-weight:bold'>NPA</td><td style='padding-left:20px'>:</td><td style='padding-left:20px;'>${npaNumber}</td></tr>`,
          `<tr><td style='font-weight:bold'>Tipe Ujian</td><td style='padding-left:20px'>:</td><td style='padding-left:20px;'>AASI</td></tr>`,
          `<tr><td style='font-weight:bold'>Lokasi Ujian</td><td style='padding-left:20px'>:</td><td style='padding-left:20px;'>${dataAASI.aajiExamLocation}</td></tr>`,
          `<tr><td style='font-weight:bold'>Tanggal Ujian</td><td style='padding-left:20px'>:</td><td style='padding-left:20px;'>${t(
            moment(dataAASI.aajiExamDate).format("dddd"),
          )}, ${moment(dataAASI.aajiExamDate).format("DD")} ${t(
            moment(dataAASI.aajiExamDate).format("MMMM"),
          )} ${moment(dataAASI.aajiExamDate).format("yyyy")}</tr>`,
          `<tr><td style='font-weight:bold;align-content:start'>Waktu Ujian</td><td style='padding-left:20px;align-content:start'>:</td><td style='padding-left:20px;'>${dataAASI.aajiExamStartTime} - ${dataAASI.aajiExamEndTime}<br>(Kuota Terisi: ${dataAASI.aajiExamQuotaFilled}/${dataAASI.aajiExamQuota})</td></tr></table>`,
        ];
        confirm({
          title: "JADWAL AASI",
          message: templateScheduleAASI.join(""),
          confirmButtonText: "OK",
          disableCancel: true,
        });
      }
    } else {
      var totalSectionComplete = 0;
      var totalSectionUnComplete = 0;
      var countSection: any;
      for (var key in section) {
        totalSectionComplete += section[key].denominator;
        totalSectionUnComplete += section[key].numerator;
      }
      navigate(`${ROOT_PATH}/${ONBOARDING_PATH}/form?${query.toString()}`);
    }
  };

  return (
    <div
      className={`${style["list-container"]} ${style.flex1} ${style["flex-column"]} ${style.padding}`}>
      <List>
        {sections.map((section) => {
          return (
            <div key={section.name} className={`${style.item}`}>
              <ListSubheader sx={subheader}>
                <ListItemButton
                  onClick={() => {
                    onClick(section.name);
                  }}>
                  {section.status === StatusEnum.completed ? (
                    <Box sx={completeBoxMarginStyle}>
                      <CheckIcon sx={completeIconStyle} />
                    </Box>
                  ) : (
                    <ListItemText
                      sx={sectionItem}
                      primary={`(${section.numerator}/${section.denominator})`}
                    />
                  )}
                  <ListItemText primary={section.title} />
                  {expand.has(section.name) ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListSubheader>
              <Collapse in={expand.has(section.name)}>
                <div className={`${style["padding-left-right"]}`}>
                  <List>
                    {section.data.map((d) => {
                      return (
                        <div className={`${style["item-child"]}`} key={d.name}>
                          <ListItemButton
                            onClick={() => {
                              checkStepComplete(d, sections);
                            }}>
                            <Box
                              display="flex"
                              flexDirection="column"
                              width="100%"
                              component="ul"
                              style={{ color: color.majorRed }}
                              sx={{ pl: 2, m: 0, listStyleType: "disc" }}>
                              <ListItemText sx={item} primary={d.title} />
                              {d.title == "Tanda Tangan" &&
                                getRoleMessage().map((msg, index) => (
                                  <li key={index}>
                                    <Typography variant="caption" sx={{ color: color.majorRed }}>
                                      {msg}
                                    </Typography>
                                  </li>
                                ))}
                            </Box>
                            <StatusIcon status={d.status}></StatusIcon>
                          </ListItemButton>
                        </div>
                      );
                    })}
                  </List>
                </div>
              </Collapse>
            </div>
          );
        })}
      </List>
    </div>
  );
};

const StatusIcon = ({ status }: { status?: keyof typeof StatusEnum }) => {
  switch (status) {
    case StatusEnum.completed:
      return (
        <Box sx={completeBoxStyle}>
          <CheckIcon sx={completeIconStyle} />
        </Box>
      );
    case StatusEnum.editing:
      return <img src={arrowRight} alt="banner"></img>;
    case StatusEnum.untouched:
      return <ChevronRightIcon />;
  }
  return <></>;
};
